
export interface AirtableDatasourceConfig {
    baseId: string;
    baseName: string;
    tableId: string;
    tableName: string;
};

export interface GoogleSheetDatasourceConfig {
    docId: string;
    sheetId: number;
    sheetName: string;
};


export interface APIDatasourceConfig {
    url?: string;
    interface?: "json" | "csv" | "xml";
    method?: "GET" | "POST";
    headers?: string;
    body?: string;
    transform?: string;
};


export interface ClickhouseConfig {
    url: string;
    pathname: string;
    username: string;
    password: string;
    database: string;
    query: string;
};

export interface BigQueryDatasourceConfig {
    credentials: string;
    projectId: string;
    query: string;
    location: string;
};

export interface CSVDatasourceConfig {
    url?: string;
    filename?: string;
};

export interface ExcelDatasourceConfig {
    url?: string;
    filename?: string;
    sheetName?: string;
};

export interface FirestoreDatasourceConfig {
    type: string;
    project_id: string;
    private_key_id: string;
    private_key: string;
    client_email: string;
    client_id: string;
    auth_uri: string;
    token_uri: string;
    auth_provider_x509_cert_url: string;
    client_x509_cert_url: string;
    universe_domain: string;
    databaseURL: string;

    query_type: "collection" | "firestore";
    collection?: string;
    subcollection?: string;
};
export interface MongoDBDatasourceConfig {
    url: string;
    database: string;
    collection: string;
};

export interface MsSQLDatasourceConfig {
    server: string;
    port: string;
    user: string;
    password: string;
    database: string;
    query: string;
};
export interface FivetranConfig {
    tables: string[];
    tableId: string;
    tableName: string;
    proMode: boolean;
    query: string;
    schema: string;
};

export interface AirbyteConfig {
    streams: { name: string, fields: string[] }[];
    streamId: string;
    proMode: boolean;
    query: string;
    schema: string;
}

// TODO: FIX THE CASING
export interface MySQLDatasourceConfig {
    host: string;
    user: string;
    port: string;
    password: string;
    database: string;
    query: string;

    ssh_enabled?: boolean;
    ssh_host?: string;
    ssh_username?: string;
    ssh_port?: string;
    ssh_private_key?: string;
};


export interface PostgreSQLDatasourceConfig {
    host: string;
    port: string;
    database: string;
    user: string;
    password: string;
    query: string;
};


// Add a dummy export to ensure this file is included
export const __ensureFileIsEmitted = true;